import styled from 'styled-components'

export default styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${props => (props.isEnabled ? '#89de6e' : '#f77474')};
  display: ${props => (props.isEventEnrichment ? 'none' : 'block')};
`
